export default "__VITE_ASSET__Civs48ql__"